import { MiscUtil } from './MiscUtil';

namespace TypeUtil {
  export function GetField<T>(obj: object, v: string): T {
    // tslint:disable-next-line:no-any whitespace
    return (<any>obj)[v];
  }
  // tslint:disable-next-line:no-any
  export function SetField(obj: object, v: string, value: any): void {
    // tslint:disable-next-line:no-any whitespace
    (<any>obj)[v] = value;
  }
  export function HasField(obj: object, v: string): boolean {
    return !MiscUtil.IsNullOrUndefined(GetField(obj, v));
  }
  export function HasMethod(obj: object, v: string): boolean {
    return !MiscUtil.IsNullOrUndefined(GetField(obj, v))
      && (typeof (GetField(obj, v)) === 'function');
  }
}

export { TypeUtil };
